import { getISODateTime } from "../../utils/momentUtils";

// ------------- Form Data for Save ------------- //

export const createDoctorCommissionProgramFormData = (data) => {
  return {
    doctorCommissionName: data.doctorCommissionName,
    startDate: getISODateTime(data.startDate),
    endDate: getISODateTime(data.endDate),
    doctorCommissionDetails: data.doctorCommissionDetails,
    manufacturerGroupId: data.manufacturerGroupId,
    medicineForm: data.manufacturerGroupId !== "1ON" ? data.medicineForm : [],
    doctorType: data.doctorType,
  };
};

export const createDoctorCommissionProgramItemFormData = (data, isEdit = false) => {
  return {
    min: data.min,
    max: data.max,
    commissionPercentage: data.commissionPercentage,
    doctorCommissionDetailsId: data.doctorCommissionDetailsId,
    doctorCommissionId: data.doctorCommissionId,
  };
};